import { Spinner } from "@chakra-ui/react";
import jwtDecode from "jwt-decode";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getAuthToken, removeAuthToken } from "../utils/token";

const PrivateRoute = ({ roles, children }: any) => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(true);
  const [authRole, setAuthRole] = useState<string | null>(null);
  const { setAuth } = useAuth();

  useEffect(() => {
    async function validate() {
      const token = await getAuthToken();
      try {
        if (token) {
          const decoded: any = jwtDecode(token);
          const currentDate = new Date();

          if (currentDate.getTime() >= decoded.exp * 1000) {
            setLoggedIn(false);
            setLoading(false);
            await removeAuthToken();
          } else {
            setLoggedIn(true);
            setLoading(false);
            setAuth(decoded);
            setAuthRole(decoded?.role);
          }
        } else {
          if (isEmpty(token)) {
            setLoggedIn(false);
            setLoading(false);
            await removeAuthToken();
          }
        }
      } catch (error) {
        setLoggedIn(false);
        setLoading(false);
        removeAuthToken();
      }
    }

    validate();
  }, [setAuth]);

  if (loading) {
    return <Spinner />;
  }

  if (!loggedIn) {
    return <Navigate to="/auth" replace />;
  }

  return children && roles.some((role: any) => role === authRole) ? (
    children
  ) : (
    <Outlet />
  );
};

export default PrivateRoute;
